import { render } from "./OneclickBooking.vue?vue&type=template&id=7ea615a2&scoped=true"
import script from "./OneclickBooking.vue?vue&type=script&lang=js"
export * from "./OneclickBooking.vue?vue&type=script&lang=js"

import "./OneclickBooking.vue?vue&type=style&index=0&id=7ea615a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea615a2"]])

export default __exports__